export default __webpack_public_path__ + "static/media/361.d6a60b86.gif";